// initial state
import axios from "axios";

const state = () => ({
    all: []
})

// getters
const getters = {}

// actions
const actions = {
    async getAll ({ commit }) {
        axios.get(route('frontend.fixture.list')).then(result => {
            commit('setFixtures', result.data)
        });
    }
}

// mutations
const mutations = {
    setFixtures (state, fixtures) {
        state.all = fixtures
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
